export default "__VITE_ASSET__d0MKLa8B__"